define('GameDayCore/GDModel/load/flow/LiveHeartbeatFlow',['require','exports','module','../../enums/datasources/Datasources','./HeartbeatFlow','../../../GDControl/GameModelLocator/GameModelLocator','../../storage/ModelCache','../../storage/ResponseCache','data-fetcher/data-fetcher','../../../GDControl/SubscriptionManager/SubscriptionManager','message-service/message-service','../../enums/datasources/Datasources','../../enums/datasources/DatasourceToEventMap','../../enums/events/EventTypes','gameday-index-enums/enums/baseball/GameStates','../../../GDUtil/resources/GDConfig','extant/extant','../../../GDUtil/window/Logg','../execute/FileRequestItem','../../ValueObjects/Scoreboard/AllInnings','../../../GDUtil/dataMapping/GameStateUtil','../../../GDUtil/resources/GDConfig','extant/extant','../../../GDUtil/window/Logg','../execute/FileRequestItem','../../ValueObjects/Scoreboard/AllInnings','../../../GDControl/TfsManager/TfsManager','jquery'],function(require,exports,module){
    var Datasources = require("../../enums/datasources/Datasources"),
        HeartbeatFlow = require( "./HeartbeatFlow" ),

        GameModelLocator = require("../../../GDControl/GameModelLocator/GameModelLocator"),
        ModelCache = require("../../storage/ModelCache"),
        ResponseCache = require("../../storage/ResponseCache"),
        dataFetcher = require("data-fetcher/data-fetcher"),
        SubsManager = require("../../../GDControl/SubscriptionManager/SubscriptionManager"),
        MessageService = require("message-service/message-service"),
        Datasources = require("../../enums/datasources/Datasources"),
        DatasourceToEventMap = require("../../enums/datasources/DatasourceToEventMap"),
        EventTypes = require("../../enums/events/EventTypes"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        GDConfig = require("../../../GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        logg = require("../../../GDUtil/window/Logg"),
        FileRequestItem = require("../execute/FileRequestItem"),
        AllInningsVO = require("../../ValueObjects/Scoreboard/AllInnings"),
        GameStateUtil = require("../../../GDUtil/dataMapping/GameStateUtil"),
        GDConfig = require("../../../GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        logg = require("../../../GDUtil/window/Logg"),
        FileRequestItem = require("../execute/FileRequestItem"),
        AllInningsVO = require("../../ValueObjects/Scoreboard/AllInnings"),
        TfsManager = require("../../../GDControl/TfsManager/TfsManager"),
        jquery = require('jquery');

    var Superclass;

    function LiveHeartbeatFlow(worker){
        var that = this;

        this.firstRun = true;
        this.lastPlays = {};
        Superclass.constructor.call(this,worker,this.handlePlaysFileLoaded,Datasources.PLAYS);
        this.addItem(this.refreshPlaysDependentFiles);
        this.setAllInningsCallback = function(){
            that.setAllInnings.apply(that,arguments);
        }
    }
    HeartbeatFlow.spawn(LiveHeartbeatFlow).define({

        /**
         * handlePlaysFileLoaded
         * @param res {Object} value object + Load details from datasource Manager
         *
         * store the data and current gamestate
         * update init progress (if needed)
         * if the file has changed, initiate plays-depenedent file loads
         */
        handlePlaysFileLoaded : function(res) {
            // null point check
            if (!exists(res.data)) {
                logg.error("The data call was null, not much to do with that, dude: ", res);
                this.queue.fail(res);
                return;
            }

            // store ref to the data locally
            var plays = this.plays = res.data;

            // if plays file is updated... get some other stuff movingq
            if (ResponseCache.responseHasChanged(res.dataSourceName) || !ResponseCache.responseExists(res.dataSourceName)) {
                logg.log("Live flow :: plays loaded");
                GDConfig.wait = parseInt(plays.wait);
                // ModelCache.storeGameData(gameID, res.dataSourceName, playsFileResult, (new Date()).getTime());
                this.expireDataSources();
                this.processUpdates();
                return;
            } 
            
            logg.log("Live flow :: plays file unchanged");
            this.queue.resolve(res);
        },
         /**
         * Function expireDataSources
         * @param params {Object} name-value pairs of game info relevant to Load pathing
         *
         * iterates through the list of subscribed Datasources and expires each datasource
         * except for plays and all innings
         */
        expireDataSources : function() {
            this.worker.gameItem.expireGameData();
        },
        /**
         * Function processUpdates
         *
         * Logical breakdown of which files to Load if the plays file has been updated
         */
        processUpdates : function() {
            var plays           = this.plays,
                lastPlays       = this.lastPlays,
                atbat           = plays.atbat,
                lastAtbat       = lastPlays.atbat,
                atbatChanged    = !!atbat !== !!lastAtbat,
                boxChanged      = lastPlays.box != plays.box,
                inningChanged   = lastPlays.inning !== plays.inning,
                refreshBatterHotColdZone = false,
                updateNeeded    = false;


            switch(true){
                    // Just getting started
                case (this.firstRun):
                    logg.log("heartbeat - first run");
                    updateNeeded = true;
                break;
                // New inning
                case (boxChanged || inningChanged):
                    logg.log("heartbeat - inning changed");

                // New atbat appeared or old atbat disappeared
                case atbatChanged:
                    logg.log("heartbeat - atbat changed");
                    refreshBatterHotColdZone = true;
                // Description populated and it's not the same as the last atbat
                case (!!atbat && atbat.des.length && atbat.des !== lastAtbat.des):
                    logg.log("heartbeat - atbat description populated, and it ending");

                // Atbat number changed
                case atbat.num !== lastAtbat.num:
                    logg.log("heartbeat - atbat number has changed");
                    refreshBatterHotColdZone = true;
                // Outs change to 3
                case plays.outs == 3 && lastPlays.outs != 3:
                    logg.log("heartbeat - atbat outs changed to 3");
                    updateNeeded = true;
                break;

                default:
                    logg.log("heartbeat - skip dependency refresh and send update");
                    updateNeeded = false;
            }

            this.firstRun = false;
            this.lastPlays = plays;
            this.refreshBatterHotColdZone = refreshBatterHotColdZone;
            if(updateNeeded){
                this.nextItem()
            } else {
                this.complete();
            }
        },     

        /**
         * Function refreshPlaysDependentFiles
         *
         * calls for loads of secondary files after plays file update
         * checks subscriptions
         */
        refreshPlaysDependentFiles : function() {
            var params = this.worker.gameItem.addGameParams({"inning": this.plays.inning}),
                primaryLoad     = [ Datasources.INNING, Datasources.LINESCORE, Datasources.BOXSCORE ],
                secondaryLoad   = [ Datasources.BENCH, Datasources.SCORING_PLAYS ].filter(SubsManager.checkSubscription),
                hotcoldLoad     = this.refreshHotColdZone('batter', this.plays.atbat, 'zn');

            logg.info("Heartbeat.refreshPlaysDependentFiles", primaryLoad, secondaryLoad, Datasources.HOT_COLD_ZONE);
            if(hotcoldLoad){
                secondaryLoad.push(hotcoldLoad);
            }
            this.worker.queue(primaryLoad.concat(secondaryLoad),params)
                .always(this.setAllInningsCallback).always(this.nextItemCallback);

            if (SubsManager.checkSubscription(Datasources.VIDEO)){
                this.worker.fetch(Datasources.VIDEO,params); // not sent through dependent file Load function as it is not viewed as vital
            }
        },
        /**
         * Find the inning result when the callbacks end, and store it
         */
        setAllInnings : function(result) {
            var ALL_INNINGS = Datasources.ALL_INNINGS,
                i=0,
                len = arguments.length;
            // Find the inning result when it's all done
            for(; i < len; i++){
                if( arguments[i].dataSourceName === Datasources.INNING ){
                    this.worker.storeLoaded(jquery.extend({},result,{
                        dataSourceName  : Datasources.ALL_INNINGS,
                        data            : new AllInningsVO(result.data, true)
                    }));
                    return;
                }
            }
        },
         /**
         * Function refreshHotColdZone
         * @param position {String} batter or pitcher
         * @param playerID {String} the players numerical id
         * @param situation {String} the situation file to reference
         *
         * Extends the base game values in the param object
         * and initiates a Load through the datascource Manager
         */
        refreshHotColdZone : function(position, atbat, situation) {
            var ls = this.worker.gameItem.getGameData(Datasources.LINESCORE).linescore,
                playerID = exists(atbat,position) && atbat[position],
                // Check if this game has premium content
                situationExists = exists(ls,'gameday_sw') && ls.gameday_sw === "P";

            if (!SubsManager.checkSubscription(Datasources.HOT_COLD_ZONE) || !situationExists || !playerID || !exists(situation)) {
                logg.info("Huururlg!! Skipping hot/cold zone - zn.xml", "gameday_sw = "+ls.gameday_sw);
                return null;
            }
            logg.log("Heartbeat.refreshHotColdZone", position, playerID, situation);
            var params = this.worker.gameItem.addGameParams({
                id: playerID,
                playertype: position,
                sit: situation
            });
            return this.worker.fetch(Datasources.HOT_COLD_ZONE,params);
        }

    });

    Superclass = LiveHeartbeatFlow.superclass;
    return LiveHeartbeatFlow;
});
